<p-card
  class="config-card"
  [class.config-card--focusable]="!disabled() && !isBadgeHovered()"
  [class.config-card--disabled]="disabled()"
  [attr.role]="!disabled() ? 'button' : null"
  [attr.tabindex]="!disabled() ? 0 : null"
  (click)="!disabled() && !isBadgeHovered() && navigateToRoute()"
  (keydown.enter)="!disabled() && !isBadgeHovered() && navigateToRoute()"
>
  @if (content().status; as status) {
    <div class="config-card__status">
      @if (status.label) {
        <p-tag
          [severity]="status.severity"
          [value]="status.label | translate"
          [pTooltip]="status.tooltip | translate: status.tooltipParams"
          tooltipPosition="top"
        />
      } @else {
        <p-badge
          [severity]="status.severity"
          badgeSize="small"
          class="p-badge-dot"
          [pTooltip]="status.tooltip | translate: status.tooltipParams"
          tooltipPosition="top"
        />
      }
    </div>
  }

  <p-avatar
    [image]="useImage() ? avatarImage() : undefined"
    [label]="!useImage() ? avatarLabel() : undefined"
    shape="square"
    class="config-card__avatar"
    (onImageError)="handleImageError()"
  />

  @if (content().title) {
    <span class="config-card__title">{{ content().title | translate }}</span>
  }

  @if (content().body) {
    <ng-container *ngComponentOutlet="content().body!.component; inputs: content().body!.inputs" />
  }

  @if (content().badges.length > 0) {
    <div
      class="config-card__badges"
      (mouseenter)="isBadgeHovered.set(true)"
      (mouseleave)="isBadgeHovered.set(false)"
    >
      <du-config-amount-badges [badges]="content().badges" />
    </div>
  }
</p-card>
